import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext, HttpStatusCode } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';

import { LOADER_CONTEXT } from '../../../../services/interceptors/loader.interceptor';
import { DevicesPayload } from '../../../equipment/devices/components/devices.models';
import {
  EventConfigurationOverrideAPIBody,
  EventConfigurationResponse,
  EventGroupsResponse,
  EventGroupsWithEventNamesResponse
} from './event-configuration-api.type';

@Injectable({
  providedIn: 'root'
})
export class EventConfigurationApiService {
  private readonly http = inject(HttpClient);

  private readonly eventTypesURL = `/api/event-types`;
  private eventGroupsWithEventNames$!: Observable<EventGroupsWithEventNamesResponse[]>;

  getAll(tableState?: DevicesPayload): Observable<EventConfigurationResponse> {
    return this.http.post<EventConfigurationResponse>(`${this.eventTypesURL}`, tableState, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }

  // TODO This endpoint is new but instead of it should be used getEventGroupsWithEventNames
  // because it has all data for groups and names simultaneously
  getEventGroups(): Observable<EventGroupsResponse[]> {
    return this.http.get<EventGroupsResponse[]>(`${this.eventTypesURL}/groups`);
  }

  getEventGroupsWithEventNames(): Observable<EventGroupsWithEventNamesResponse[]> {
    if (!this.eventGroupsWithEventNames$) {
      this.eventGroupsWithEventNames$ = this.http
        .get<EventGroupsWithEventNamesResponse[]>(`${this.eventTypesURL}/events`)
        .pipe(shareReplay(1));
    }

    return this.eventGroupsWithEventNames$;
  }

  overrideEventConfig(eventConfig: EventConfigurationOverrideAPIBody): Observable<HttpStatusCode> {
    return this.http.post<HttpStatusCode>(`${this.eventTypesURL}/override`, eventConfig);
  }
}
